interface SvgTrashCanProps {
  className?: string;
  width?: number | string;
  height?: number | string;
}
export default function SvgTrashCan(props: SvgTrashCanProps) {
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}><path d="M21 5.25V6.75H19.6562L17.8594 20.2314C17.7434 21.1008 17.0011 21.75 16.124 21.75H7.87598C6.99891 21.75 6.2566 21.1008 6.14062 20.2314L4.34375 6.75H3V5.25H21ZM7.62793 20.0332C7.64457 20.1573 7.75074 20.25 7.87598 20.25H16.124C16.2493 20.25 16.3554 20.1573 16.3721 20.0332L18.1436 6.75H5.85645L7.62793 20.0332ZM15 2.25V3.75H9V2.25H15Z" fill="currentColor" /></svg>;
}